
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  FaUserCog,
  FaMoneyCheckAlt,
  FaUsers,
  FaCogs,
  FaTachometerAlt,
  FaRegCreditCard,
  FaWallet,
  FaBars,
  FaTimes,
  FaChevronLeft,
  FaChevronRight,
  FaFileUpload,
  FaBell,
  FaFileAlt,
  FaChevronDown,
  FaChevronUp,
  FaIdCard
} from "react-icons/fa";
import { GrOrganization } from "react-icons/gr";
import { Nav, NavItem, NavLink, NavbarBrand } from "reactstrap";
import "../../styles/common/Sidebar.css";

export default function Sidebar({ role }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(
    () => (localStorage.getItem("sidebarCollapsed") === "true")
  );
  const [expandedMenu, setExpandedMenu] = useState(null);
  const [expandedNestedMenu, setExpandedNestedMenu] = useState(null);
  // const normalizedRole =
  //   role?.toLowerCase() === "superadmin" ? "SuperAdmin" : role;

  //   const basePath = normalizedRole === "SuperAdmin" ? "/super-admin" : "/admin" ;

  const normalizedRole =
    role?.toLowerCase() === "superadmin"
      ? "SuperAdmin"
      : role?.toLowerCase() === "admin"
        ? "Admin"
        : role?.toLowerCase() === "subadmin"
          ? "SubAdmin"
          : role?.toLowerCase() === "user"
          ? "User"
          : role?.toLowerCase() === "orguser"
          ? "OrgUser"
          : role;

  // Define base path based on role
  let basePath = "/";

  if (normalizedRole === "SuperAdmin") {
    basePath = "/super-admin";
  } else if (normalizedRole === "Admin") {
    basePath = "/admin";
  } else if (normalizedRole === "SubAdmin") {
    basePath = "/sub-admin";
  } else if (normalizedRole === "User") {
    basePath = "/user";
  } else if (normalizedRole === "OrgUser") {
    basePath = "/orguser";
  }


  const menu = {
    SuperAdmin: [
      { to: "/super-admin/admins", label: "Admins", icon: <FaUserCog /> },
      { to: "/super-admin/sub-admins", label: "Coordinate Agents", icon: <FaUserCog /> },
      { to: "/super-admin/organizations", label: "Organizations", icon: <GrOrganization /> },
      { to: "/super-admin/users", label: "Organization Users", icon: <FaUsers /> },
      { to: "/super-admin/registration-requests", label: "Registration Requests", icon: <FaFileAlt /> },
      { to: "/super-admin/transaction-history", label: "Transaction History", icon: <FaWallet /> },
      { to: "/super-admin/credit-reports", label: "Credit Reports", icon: <FaRegCreditCard /> },
      { to: "/super-admin/kyc-verifications", label: "KYC Verification Reports", icon: <FaIdCard /> },
      { to: "/super-admin/uploaded-data", label: "Uploaded Data", icon: <FaFileUpload /> },
      { to: "/super-admin/commissions", label: "Credit Settings", icon: <FaMoneyCheckAlt /> },
      { to: "/super-admin/bank-act", label: "Bank Acts", icon: <FaMoneyCheckAlt /> },
      { to: "/super-admin/reports", label: "Organization Reports", icon: <FaFileAlt /> },
      { to: "/super-admin/sub-admin-reports", label: "Coordinate Agent Reports", icon: <FaUserCog /> },
      { to: "/super-admin/support-tickets", label: "Support Ticket", icon: <FaCogs /> },
      { to: "/super-admin/notifications", label: "Notifications", icon: <FaBell /> },
    ],
    Admin: [
      { to: "/admin/sub-admins", label: "Coordinate Agents", icon: <FaUserCog /> },
      { to: "/admin/organizations", label: "Organizations", icon: <GrOrganization /> },
      { to: "/admin/users", label: "Organization Users", icon: <FaUsers /> },
      { to: "/admin/registration-requests", label: "Registration Requests", icon: <FaFileAlt /> },
      { to: "/admin/transaction-history", label: "Transaction History", icon: <FaWallet /> },
      { to: "/admin/credit-reports", label: "Credit Reports", icon: <FaRegCreditCard /> },
      { to: "/admin/kyc-verifications", label: "KYC Verification Reports", icon: <FaIdCard /> },
      { to: "/admin/uploaded-data", label: "Uploaded Data", icon: <FaFileUpload /> },
      { to: "/admin/reports", label: "Organization Reports", icon: <FaFileAlt /> },
      { to: "/admin/sub-admin-reports", label: "Coordinate Agent Reports", icon: <FaUserCog /> },
      { to: "/admin/support-tickets", label: "Support Ticket", icon: <FaCogs /> },
      { to: "/admin/notifications", label: "Notifications", icon: <FaBell /> },
    ],
    SubAdmin: [
      { to: "/sub-admin/organizations", label: "Organizations", icon: <GrOrganization /> },
      { to: "/sub-admin/users", label: "Organization Users", icon: <FaUsers /> },
      { to: "/sub-admin/reports", label: "Organization Reports", icon: <FaFileAlt /> },
    ],
    OrgUser: [
      { to: "/orguser", label: "Dashboard", icon: <FaTachometerAlt /> },
      {
        label: "KYC Verification",
        icon: <FaIdCard />,
        dropdown: true,
        submenu: [
          { to: "/orguser/kyc/pan-verification", label: "PAN Verification" },
          // { to: "/orguser/kyc/pan-to-bank-account", label: "PAN To Bank Account" }, // hidden per request
          { to: "/orguser/kyc/mobile-to-bank-account", label: "Mobile To Bank Account" },
          { to: "/orguser/kyc/court-case-check", label: "Court Case Check" },
          { to: "/orguser/kyc/dl-verification", label: "DL Verification" },
          { to: "/orguser/kyc/rc-verification", label: "RC Verification" }
        ]
      },
      { 
        label: "Credit Score Checks", 
        icon: <FaRegCreditCard />,
        dropdown: true,
        submenu: [
          { 
            label: "Credit Score Check (With OTP)",
            nestedDropdown: true,
            nestedSubmenu: [
              { to: "/orguser/credit-checks/with-otp?plan=basic", label: "Basic Plan", planType: "Basic", mode: "with-otp" },
              { to: "/orguser/credit-checks/with-otp?plan=advanced", label: "Advance Plan", planType: "Advanced", mode: "with-otp" },
              { to: "/orguser/credit-checks/with-otp?plan=combo", label: "Combo Plan", planType: "Combo", mode: "with-otp" }
            ]
          },
          { 
            label: "Credit Score Check (Without OTP)",
            nestedDropdown: true,
            nestedSubmenu: [
              { to: "/orguser/credit-checks/without-otp?plan=basic", label: "Basic Plan", planType: "Basic", mode: "without-otp" },
              { to: "/orguser/credit-checks/without-otp?plan=advanced", label: "Advance Plan", planType: "Advanced", mode: "without-otp" },
              { to: "/orguser/credit-checks/without-otp?plan=combo", label: "Combo Plan", planType: "Combo", mode: "without-otp" }
            ]
          }
        ]
      },
      { to: "/orguser/credit-reports", label: "Credit Reports", icon: <FaMoneyCheckAlt /> },
      { to: "/orguser/wallet", label: "Wallet", icon: <FaWallet /> },
      { to: "/orguser/upload-data", label: "Upload Data", icon: <FaFileUpload /> },
      { to: "/orguser/support-tickets", label: "Support Tickets", icon: <FaCogs /> },
      { to: "/orguser/activity-logs", label: "Activity Logs", icon: <FaUsers /> },
      { to: "/orguser/notifications", label: "Notifications", icon: <FaBell /> },
    ],
  };

  const items = menu[normalizedRole] || [];
  const panelLabel = normalizedRole === "SubAdmin" ? "Coordinate Agent" : `${normalizedRole} Panel`;

  const toggleMobile = () => setMobileOpen(!mobileOpen);
  const closeMobile = () => setMobileOpen(false);

  const toggleCollapsed = () => {
    const next = !collapsed;
    setCollapsed(next);
    localStorage.setItem("sidebarCollapsed", String(next));
  };

  useEffect(() => {
    const savedCollapsed = localStorage.getItem("sidebarCollapsed");
    if (savedCollapsed === "true" || savedCollapsed === "false") {
      setCollapsed(savedCollapsed === "true");
    }
  }, []);

  useEffect(() => {
    // Reflect collapsed state on body for content layout
    if (collapsed) {
      document.body.classList.add("sidebar-collapsed");
    } else {
      document.body.classList.remove("sidebar-collapsed");
    }
  }, [collapsed]);

  return (
    <>
      {/* ----- Mobile Hamburger (visible <768px) ----- */}
      <button
        className="x-mobile-toggle d-md-none"
        onClick={toggleMobile}
        aria-label="Toggle sidebar"
      >
        {mobileOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* ----- Mobile Backdrop ----- */}
      <div 
        className={`x-sidebar-backdrop ${mobileOpen ? 'show' : ''}`}
        onClick={closeMobile}
      />

      {/* ----- Sidebar ----- */}

      <aside
        className={`x-sidebar theme-light${mobileOpen ? " x-mobile-open" : ""}${collapsed ? " x-collapsed" : ""}`}
      >
        {/* Brand */}
        {/* <div className="x-brand">
          <FaTachometerAlt className="x-brand-icon" />
          <span className="x-brand-text"  >{normalizedRole} Panel</span>
        </div> */}


        <NavbarBrand tag={Link} to={basePath} className="x-brand d-flex justify-content-between align-items-center">
          <span className="x-brand-text">{panelLabel}</span>
          <div className="d-flex align-items-center gap-2">
            <button
              type="button"
              className="x-collapse-toggle"
              aria-label={collapsed ? "Expand sidebar" : "Collapse sidebar"}
              onClick={toggleCollapsed}
              title={collapsed ? "Expand sidebar" : "Collapse sidebar"}
            >
              {collapsed ? <FaChevronRight /> : <FaChevronLeft />}
            </button>
          </div>
        </NavbarBrand>
        {/* Nav */}
        <Nav vertical className="x-nav">
          {items.map((it, i) => (
            <NavItem key={i} className="x-nav-item">
              {it.dropdown ? (
                <>
                  <div
                    className="x-nav-link x-dropdown-toggle"
                    onClick={() => {
                      const nextMenu = expandedMenu === i ? null : i;
                      setExpandedMenu(nextMenu);
                      if (nextMenu === null) {
                        setExpandedNestedMenu(null);
                      }
                    }}
                    aria-label={it.label}
                    title={collapsed ? it.label : undefined}
                  >
                    <span className="x-icon">{it.icon}</span>
                    <span className="x-label">{it.label}</span>
                    <span className="x-dropdown-icon">
                      {expandedMenu === i ? <FaChevronUp /> : <FaChevronDown />}
                    </span>
                  </div>
                  {expandedMenu === i && (
                    <div className="x-submenu">
                      {it.submenu.map((subItem, j) => (
                        <div key={j}>
                          {subItem.nestedDropdown ? (
                            <>
                              <div
                                className="x-submenu-link x-nested-dropdown-toggle"
                                onClick={() => setExpandedNestedMenu(expandedNestedMenu === `${i}-${j}` ? null : `${i}-${j}`)}
                                aria-label={subItem.label}
                              >
                                <span className="x-nested-label">{subItem.label}</span>
                                <span className="x-nested-dropdown-icon">
                                  {expandedNestedMenu === `${i}-${j}` ? <FaChevronUp /> : <FaChevronDown />}
                                </span>
                              </div>
                              {expandedNestedMenu === `${i}-${j}` && (
                                <div className="x-nested-submenu">
                                  {subItem.nestedSubmenu.map((nestedItem, k) => (
                                    <NavLink
                                      key={k}
                                      tag={Link}
                                      to={nestedItem.to}
                                      className="x-nested-submenu-link"
                                      onClick={closeMobile}
                                      aria-label={nestedItem.label}
                                    >
                                      {nestedItem.label}
                                    </NavLink>
                                  ))}
                                </div>
                              )}
                            </>
                          ) : (
                            <NavLink
                              tag={Link}
                              to={subItem.to}
                              className="x-submenu-link"
                              onClick={closeMobile}
                              aria-label={subItem.label}
                            >
                              {subItem.label}
                            </NavLink>
                          )}
                        </div>
                      ))}
                    </div>
                  )}
                </>
              ) : (
                <NavLink
                  tag={Link}
                  to={it.to}
                  className="x-nav-link"
                  onClick={closeMobile}
                  aria-label={it.label}
                  title={collapsed ? it.label : undefined}
                >
                  <span className="x-icon">{it.icon}</span>
                  <span className="x-label">{it.label}</span>
                </NavLink>
              )}
            </NavItem>
          ))}
        </Nav>
      </aside>
    </>
  );
}